(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/javascripts/handlebarshelpers.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/javascripts/handlebarshelpers.js');
"use strict";

(function () {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
  function registerHelpers(hbs) {
    hbs.registerHelper('moduleTemplateBase', (templateBase, context) => {
      let templateSrc;
      if (typeof templateBase === 'string') {
        templateSrc = templateBase;
      } else {
        templateSrc = "svs-".concat(context.data.root.modulePath);
      }
      return "".concat(templateSrc, "-");
    });
    hbs.registerHelper('none', function () {
      const params = Array.prototype.slice.call(
      arguments, 0, arguments.length - 1);
      const options = arguments[arguments.length - 1];
      let i = params.length;
      while (i--) {
        if (params[i]) {
          return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
        }
      }
      return options && typeof options.fn === 'function' ? options.fn(this) : true;
    });
    hbs.registerHelper('all', function () {
      const params = Array.prototype.slice.call(
      arguments, 0, arguments.length - 1);
      const options = arguments[arguments.length - 1];
      let i = params.length;
      while (i--) {
        if (!params[i]) {
          return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
        }
      }
      return options && typeof options.fn === 'function' ? options.fn(this) : true;
    });
    hbs.registerHelper('attributes', options => {
      let attributeName;
      let attributeString = '';
      for (attributeName in options.hash) {
        if (Object.prototype.hasOwnProperty.call(options.hash, attributeName)) {
          attributeString += "".concat(attributeName, "=\"").concat(options.hash[attributeName], "\" ");
        }
      }
      return attributeString;
    });

    hbs.registerHelper('getContext', model => model instanceof Array && !model.length && {} || model || {});
    hbs.registerHelper('nestedModel', function () {
      let model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return model.attributes || model;
    });
    hbs.registerHelper('conditional', function () {
      if (arguments[0]) {
        return arguments[1];
      }
      return arguments[2];
    });
    hbs.registerHelper('usePartialIfExists', function (partial, context, options) {
      let res;
      if (typeof partial === 'function') {
        res = partial(context, options);
      }
      if (res && res.length > 0) {
        return res;
      }
      return options.fn(this);
    });
    hbs.registerHelper('isEmpty', function () {
      const params = Array.prototype.slice.call(arguments, 0, arguments.length - 1);
      const options = arguments[arguments.length - 1];
      let i = params.length;
      while (i--) {
        if (params[i] && typeof params[i].size === 'function' ? params[i].size() : !isEmpty(params[i])) {
          return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
        }
      }
      return options && typeof options.fn === 'function' ? options.fn(this) : true;
    });
  }
})();

 })(window);